import { useEffect } from "react";
import { Tabs } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import SecurityTab from "./SecurityTab";
import CustomTabs from "../ui/CustomTabs/CustomTabs";

const VALID_TABS = new Set(["security"]);

export default function MyAccountPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = VALID_TABS.has(searchParams.get("tab"))
    ? searchParams.get("tab")
    : "security";

  const handleTabChange = (value) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", value);
        return next;
      },
      { replace: true },
    );
  };

  useEffect(() => {
    if (!VALID_TABS.has(searchParams.get("tab"))) {
      handleTabChange(activeTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabOptions = [{ label: "Security", value: "security" }];

  return (
    <div>
      <CustomTabs
        tabs={tabOptions}
        value={activeTab}
        onChange={handleTabChange}
      />

      <Tabs value={activeTab} onChange={handleTabChange} className="mt-4">
        <Tabs.Panel value="security">
          <SecurityTab />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
